export default __webpack_public_path__ + "static/media/logoLight.85a6dfa4.svg";